






























import Vue from 'vue';
import tOptions from './tOptions.vue';
import TMobile from './tMobile.vue';
import { companyHost } from '@/consts/companyHost';

export default Vue.extend({
  components: { tOptions, TMobile, },
  name: 'NavBar',
  data() {
    return {
      companyHost,
      TokenColorDarkText80: '#004AAD',
      showModal: false,
      isUserScrolling: false,
      logo: `${process.env.VUE_APP_NAVBAR_LOGO}`,
    };
  },
  computed: {
    backgroundColor(): string {
      return this.showModal || this.isUserScrolling
        ? 'bg-token-dark-base-background md:bg-transparent'
        : 'bg-transparent';
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      // Any code to be executed when the window is scrolled
      this.isUserScrolling = window.scrollY > 0;
    },
    showMenu() {
      this.showModal = !this.showModal;
    },
  },
});
